import { render, staticRenderFns } from "./AdPayRecordOpt.vue?vue&type=template&id=cd2dfb64"
import script from "./AdPayRecordOpt.vue?vue&type=script&lang=js"
export * from "./AdPayRecordOpt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports